import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Token } from './token';
export var TokenGroup = AwsUi.__addComponent('awsui-token-group', {
    releaseStatus: 'stable',
    properties: {
        // The direction in which tokens are aligned. It can be either horizontal or vertical.
        alignment: {
            type: 'string',
            valid: ['horizontal', 'vertical'],
            defaultValue: 'horizontal'
        },
        // An array of objects representing token items. Each token has the following properties:
        //
        // * `label` [string, mandatory]: title text of the token.
        // * `description` [string]: further explanatory guidance about the token below the label.
        // * `disabled` [boolean]: whether the token should be disabled.
        // * `labelTag` [string]: tag that provides additional guidance, shown next to the label.
        // * `tags` [string[]]: list of tags giving further guidance about the token.
        // * `dismissLabel` [string]: adds an aria-label to the dismiss button.
        // * `iconName` [string]: name of the icon, used with `awsui-icon`.
        // * `iconAlt` [string]: alternate text for the custom icon, used with `iconUrl`.
        // * `iconUrl` [string]: URL of a custom icon.
        items: {
            type: 'array',
            itemTypes: ['TokenGroup.Item']
        }
    },
    events: {
        // Fired when the user clicks on the dismiss button. The token will not be automatically removed.
        // Make sure you add a listener to this event to update your application state.
        dismiss: {
            bubbles: true,
            cancelable: false,
            detailType: 'TokenGroup.DismissDetail'
        }
    },
    render: function (m, h) {
        var _this = this;
        var cb = new LegacyClassBuilder(this).addClass('awsui-token-group').addComponentClass(this.alignment);
        // Spread can't be used to pass the item to the Token because, in GWT, the item properties are non-enumerable, and they are in their prototype
        return (AwsUi.__createElement("div", { className: cb.toClassName() }, this.items.map(function (item, itemIndex) {
            return (AwsUi.__createElement(Token, { tags: item.tags, labelTag: item.labelTag, label: item.label, iconUrl: item.iconUrl, iconName: item.iconName, iconAlt: item.iconAlt, dismissLabel: item.dismissLabel, disabled: item.disabled, description: item.description, value: item.value, __labelPrefix: item.__labelPrefix, onDismiss: function () { return _this.__fireEvent('dismiss', { itemIndex: itemIndex }); } }));
        })));
    }
});
//# sourceMappingURL=token-group.js.map